import { router } from '@inertiajs/react'
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import { Dropdown, DropdownButton, DropdownMenu, DropdownItem, DropdownLabel } from '@/components/ui'
import { useTranslations } from '@/lib/i18n'
import type { FilterValues } from '@/components/common/TransactionFilters'

/**
 * Triggers a background CSV/XLSX export of the current view (kind + active
 * filters). Redirects to the Reports list, where progress + download live.
 */
export function ExportMenu({ kind, filters }: { kind: 'payments' | 'payouts'; filters: FilterValues }) {
  const { t } = useTranslations()

  function exportAs(format: 'csv' | 'xlsx') {
    router.post('/exports', { kind, format, filters }, { preserveScroll: true })
  }

  return (
    <Dropdown>
      <DropdownButton outline>
        {t('exports.export')}
        <ChevronDownIcon />
      </DropdownButton>
      <DropdownMenu anchor="bottom end">
        <DropdownItem onClick={() => exportAs('csv')}>
          <DropdownLabel>{t('exports.as_csv')}</DropdownLabel>
        </DropdownItem>
        <DropdownItem onClick={() => exportAs('xlsx')}>
          <DropdownLabel>{t('exports.as_xlsx')}</DropdownLabel>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}
